export default "/images/bank.png?8fe7b18c64614c7e7bc75251e4ec544a";